import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {StackParamList} from '../stacks';
import {NotificationsScreen, ProfileScreen} from '../../screens/internals';
import {RemoveSuccessScreen} from '../../screens/internals/commons/success';
import {DashboardClientScreen} from '../../screens/internals/client/dashboard/Dashboard';
import {DebtorsScreen} from '../../screens/internals/client/debtors';
import {ReceivableScreen} from '../../screens/internals/client/receivables';
import {ClientProvider} from '../../context/client/State';
import {FilterPortfolioScreen} from '../../screens/internals/commons/portfolio-filter';
import {HomeClientScreen} from '../../screens/internals/client/home/Home';

const Stack = createNativeStackNavigator<StackParamList>();

type StackGroupAnonymousProps = {
  groupOptions: {
    screenOptions: {headerTransparent: boolean; headerTitle: string};
  };
};

export const NavigatorClient = ({groupOptions}: StackGroupAnonymousProps) => {
  return (
    <ClientProvider>
      <Stack.Navigator
        initialRouteName={'Dashboard'}
        screenOptions={{headerShown: false}}>
        <Stack.Group {...groupOptions}>
          <Stack.Screen name="HomeClient" component={HomeClientScreen} />
          <Stack.Screen
            name="DashboardClient"
            component={DashboardClientScreen}
          />
          <Stack.Screen
            name="PortfolioFilter"
            component={FilterPortfolioScreen}
          />
          <Stack.Screen name="Debtors" component={DebtorsScreen} />
          <Stack.Screen name="Receivables" component={ReceivableScreen} />
          <Stack.Screen name="Profile" component={ProfileScreen} />
          <Stack.Screen name="Notifications" component={NotificationsScreen} />
          <Stack.Screen name="RemoveSuccess" component={RemoveSuccessScreen} />
        </Stack.Group>
      </Stack.Navigator>
    </ClientProvider>
  );
};
